<template>
  <div class="loginWrapper" :style="$vuetify.theme.dark ? 'background: var(--v-surface_secondary-base)'
    : 'background: white'
    ">
    <form action="">
      <div class="mb-4 logoWrapper">
        <GreenLogo class="login-logo" />
      </div>
      <button class="my-4 loginButton" @click.prevent="login">
        <template v-if="loading">
          <LoadingSpinner />
        </template>
        <template v-else>
          <v-btn class="entrarButton">Entrar</v-btn>
        </template>
      </button>
      <button :style="$vuetify.theme.dark ? 'color: var(--v-text_secondary-base)'
    : 'color: var(--v-surface_selected-base)'" class="helpButton" @click.prevent="showModal">
        Precisa de ajuda para entrar?
      </button>
    </form>
    <ModalAjuda v-if="isModalVisible" @close="closeModal" />
  </div>
</template>

<script>
import LoadingSpinner from "../components/LoadingSpinner";
import ModalAjuda from "../components/Modal/ModalAjuda.vue";
import GreenLogo from "@/assets/green_logo_socialcam.svg";
import { openConnectURI } from "../config/openConnect"
export default {
  name: "LoginView",
  components: { LoadingSpinner, ModalAjuda, GreenLogo },
  data() {
    return {
      loading: false,
      username: "",
      password: "",
      isModalVisible: false,
    };
  },
  methods: {
    async login() {
      try {
        this.isLoading = true;
        window.location.href = openConnectURI;
      } catch (error) {
        console.error(error);
        return this.$toast.error(error);
      } finally {
        this.loading = false;
      }
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.loginWrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;

  form {
    width: 100%;
    max-width: 25.625rem;
    height: 17.058125rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.logoWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-logo {
  width: 360px;
  height: 65px;
}

.helpButton {
  white-space: nowrap;
  // color: var(--v-text_secondary-base);
  font-size: 0.875rem !important;
  font-weight: 400 !important;
  line-height: 20px;
}

.entrarButton {
  width: 110px;
  height: 36px;
  background-color: var(--v-primary-base) !important;
  color: var(--sc-color-on-primary);
  font-size: var(--sc-text-base);
  font-weight: var(--sc-weight-bold);
  line-height: 16px;
}
</style>
